@if (target()) {
  <a
    [finLink]="target().url"
    [external]="target().external"
    [ngClass]="colorClass() || 'nordic-blue-900-text text-icon-primary'"
    class="block no-underline align-right pr-xxsmall-r underline-hover font-body-medium-bold"
    (beforeNavigation)="linkClick.emit()"
  >
    {{ teaserTitle() }}
    <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
  </a>
}
